module.exports = __webpack_public_path__ + "static/media/campanhas.5dd6268f.png";